export default [
	{
		path: "/client/bookings",
		exact: true,
		component: "Bookings",
		load: true,
	},
];
